import styled from "@emotion/styled";

export const Container = styled("div")`
    display: flex;
    justify-content: center;
    margin-top: 16px;
`;
